import { render, staticRenderFns } from "./NewPoll.vue?vue&type=template&id=1cd04d7a&"
import script from "./NewPoll.vue?vue&type=script&lang=ts&"
export * from "./NewPoll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports